<ng-container *ngIf="featureTags && !featureTags['sf_desktop_sub_cat']">
    <div *ngIf="this.menuItems">
       
        <span class="text-uppercase pl-20 menu-title font-weight" *ngIf="this.menuItems.title && !this.menuItems.submenu">{{this.menuItems.title}}</span>
    <div class="menu-item pl-20 bo-5" *ngIf="!this.menuItems.title && this.menuItems.category_name">           
    
        <a mat-button fxLayout="row" fxLayoutAlign="start center" class="pl-0  bo-5" [routerLink]="this.menuItems.category_name === 'ALL CATEGORY' ? ['/categories'] : ['/categories', this.menuItems['category_url']]" class="menuList">
            <span class="text-uppercase bo-5">{{this.menuItems.category_name }}
            </span>
        </a>
    </div>      
    </div>
</ng-container>
<ng-container *ngIf="featureTags && featureTags['sf_desktop_sub_cat'] && menuItems && menuItems.length > 0">
    <div *ngFor="let menu of menuItems; trackBy: trackById" class="menu-item">
      
      <!-- Display for items without sub_list -->
      <ng-container *ngIf="featureTags && featureTags['ftag_all_in_side_nav_fix'];else allLinkIssueFixElse">
        <a *ngIf="!menu.sub_list || menu.sub_list?.length === 0" [routerLink]="menu.category_name === 'Previously Ordered' ? ['/previously-ordered'] : (menu['category_url'] === '' ? ['/categories'] : (setParentUrl ? ['/categories', setParentUrl, menu['category_url']] : ['/categories', menu['category_url']]))"
            mat-button style="display: block;width: 100%;">
            <span class="menu-title">{{ menu.category_name }}</span>
        </a>
      </ng-container>
      <ng-template #allLinkIssueFixElse>
        <a *ngIf="!menu.sub_list || menu.sub_list?.length === 0" [routerLink]="setParentUrl ? ['/categories',setParentUrl, menu['category_url']] : ['/categories', menu['category_url']]"
            mat-button style="display: block;width: 100%;">
          <span class="menu-title">{{ menu.category_name }}</span>
        </a>
      </ng-template>
  
      <!-- Display for items with sub_list -->
      <div *ngIf="menu.sub_list?.length > 0">
        <span fxLayout="row" fxLayoutGap="4px" style="position: relative;">
            <a mat-button style="display: block;width: 100%;" [routerLink]="['/categories', menu['category_url']]" fxFlex>
              <span class="menu-title">{{ menu.category_name }}</span>
            </a>            
            <mat-icon fxFlex="20px" class="menu-expand-icon transition-2 side-nav-icon" (click)="onIconClick($event, menu.id)">arrow_drop_down</mat-icon>
        </span>
        
        <!-- {{menu.sub_list | json}} -->
        <!-- Render sub-menu if sub_list exists -->
        <div *ngIf="menu.sub_list?.length > 0" class="sub-menu" [id]="'sub-menu-'+menu.id">
            <app-sidenav-menu [menuItems]="menu.sub_list" [parentName]="menu.category_url" [menuParentId]="0"></app-sidenav-menu>
        </div>
      </div>
    </div>
  </ng-container>
  

  <ng-container *ngIf="featureTags && featureTags['sf_side_menu_global_change']">
    <div *ngFor="let menuItem of sidenavMenuItems['desktop_links']">
      <div *ngIf="menuItem['title']['display']">
        <a mat-button *ngIf="menuItem['title']['display']['desktop'] === true" fxLayout="row"
            fxLayoutAlign="start center" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
            (click)="handleChange(menuItem)"
            [ngClass]="!!menuItem['title']['cssClass'] ? menuItem['title']['cssClass'] : ''">
            <span *ngIf="menuItem['title']['type'] === 'public'" class="text-uppercase menu-title1"
                [innerHTML]="menuItem['title']['name'] | sanitizeHtml "></span>
            <span *ngIf="menuItem['title']['type'] === 'private' && loggedIn" class="text-uppercase menu-title1"
                [innerHTML]="menuItem['title']['name'] | sanitizeHtml "></span>
        </a>
        <ng-container *ngFor="let subLinks of menuItem['links']">
          <div class="menu-item" *ngIf="subLinks['type'] === 'public' && !loggedIn"
              [class.active]="router.url === '/'+subLinks.href">
              <a mat-button *ngIf="subLinks['display'] && subLinks['display']['desktop'] === true" fxLayout="row"
                  fxLayoutAlign="start center" class="pl-0 textwrap" routerLinkActive="active-link"
                  [routerLinkActiveOptions]="{exact:true}" (click)="handleChange(subLinks)">
                  <mat-icon class="mat-icon-sm pad-right pl-10 pr-5"
                      *ngIf="subLinks['icon'] !== null && subLinks['iconType'] === 'material' && subLinks['type'] === 'public' && subLinks['href'] !== 'sign-in'">{{subLinks['icon']}}</mat-icon>
                  <span *ngIf="subLinks['type'] === 'public'  && subLinks['href'] !== 'sign-in' "
                      class="pl-5 text-uppercase" [innerHTML]="subLinks['name'] | sanitizeHtml"></span>
                  <mat-icon class="mat-icon-sm pad-right pl-10 pr-5"
                      *ngIf="subLinks['icon'] !== null && subLinks['iconType'] === 'material' && subLinks['type'] === 'public' && subLinks['href'] === 'sign-in' && !loggedIn">{{subLinks['icon']}}</mat-icon>
                  <span *ngIf="subLinks['type'] === 'public' && subLinks['href'] === 'sign-in' && !loggedIn"
                      class="pl-5 text-uppercase" [innerHTML]="subLinks['name'] | sanitizeHtml "></span>
                  <mat-icon class="mat-icon-sm pad-right pl-10 pr-5"
                      *ngIf="subLinks['icon'] !== null && subLinks['iconType'] === 'material' && subLinks['type'] === 'private' && loggedIn">{{subLinks['icon']}}</mat-icon>
                  <span *ngIf="subLinks['type'] === 'private' && loggedIn" class="pl-5 text-uppercase"
                      [innerHTML]="subLinks['name'] | sanitizeHtml "></span>
              </a>
          </div>
          <div class="menu-item" *ngIf="subLinks['type'] === 'private' && loggedIn"
              [class.active]="router.url === '/'+subLinks.href">
              <ng-container *ngIf="featureTags && featureTags['ftag_bulletin_board_on_website']">
              <a mat-button *ngIf="subLinks['display'] && subLinks['display']['desktop'] === true && (subLinks['name'] !== 'Bulletin Board' || storeDetails?.enable_bulletin_board)" fxLayout="row"
                  fxLayoutAlign="start center" class="pl-0 textwrap" routerLinkActive="active-link"
                  [routerLinkActiveOptions]="{exact:true}" (click)="handleChange(subLinks)">
                  <mat-icon class="mat-icon-sm pad-right pl-10 pr-5"
                      *ngIf="subLinks['icon'] !== null && subLinks['iconType'] === 'material' && subLinks['type'] === 'public' && subLinks['href'] !== 'sign-in'">{{subLinks['icon']}}</mat-icon>
                  <span *ngIf="subLinks['type'] === 'public'  && subLinks['href'] !== 'sign-in' "
                      class="pl-5 text-uppercase" [innerHTML]="subLinks['name'] | sanitizeHtml"></span>
                  <mat-icon class="mat-icon-sm pad-right pl-10 pr-5"
                      *ngIf="subLinks['icon'] !== null && subLinks['iconType'] === 'material' && subLinks['type'] === 'public' && subLinks['href'] === 'sign-in' && !loggedIn">{{subLinks['icon']}}</mat-icon>
                  <span *ngIf="subLinks['type'] === 'public' && subLinks['href'] === 'sign-in' && !loggedIn"
                      class="pl-5 text-uppercase" [innerHTML]="subLinks['name'] | sanitizeHtml "></span>
                  <mat-icon class="mat-icon-sm pad-right pl-10 pr-5"
                      *ngIf="subLinks['icon'] !== null && subLinks['iconType'] === 'material' && subLinks['type'] === 'private' && loggedIn">{{subLinks['icon']}}</mat-icon>
                  <span *ngIf="subLinks['type'] === 'private' && loggedIn" class="pl-5 text-uppercase"
                      [innerHTML]="subLinks['name'] | sanitizeHtml "></span>
              </a>
              </ng-container>
              <ng-container *ngIf="featureTags && !featureTags['ftag_bulletin_board_on_website']">
                <a mat-button *ngIf="subLinks['display'] && subLinks['display']['desktop'] === true" fxLayout="row"
                    fxLayoutAlign="start center" class="pl-0 textwrap" routerLinkActive="active-link"
                    [routerLinkActiveOptions]="{exact:true}" (click)="handleChange(subLinks)">
                    <mat-icon class="mat-icon-sm pad-right pl-10 pr-5"
                        *ngIf="subLinks['icon'] !== null && subLinks['iconType'] === 'material' && subLinks['type'] === 'public' && subLinks['href'] !== 'sign-in'">{{subLinks['icon']}}</mat-icon>
                    <span *ngIf="subLinks['type'] === 'public'  && subLinks['href'] !== 'sign-in' "
                        class="pl-5 text-uppercase" [innerHTML]="subLinks['name'] | sanitizeHtml"></span>
                    <mat-icon class="mat-icon-sm pad-right pl-10 pr-5"
                        *ngIf="subLinks['icon'] !== null && subLinks['iconType'] === 'material' && subLinks['type'] === 'public' && subLinks['href'] === 'sign-in' && !loggedIn">{{subLinks['icon']}}</mat-icon>
                    <span *ngIf="subLinks['type'] === 'public' && subLinks['href'] === 'sign-in' && !loggedIn"
                        class="pl-5 text-uppercase" [innerHTML]="subLinks['name'] | sanitizeHtml "></span>
                    <mat-icon class="mat-icon-sm pad-right pl-10 pr-5"
                        *ngIf="subLinks['icon'] !== null && subLinks['iconType'] === 'material' && subLinks['type'] === 'private' && loggedIn">{{subLinks['icon']}}</mat-icon>
                    <span *ngIf="subLinks['type'] === 'private' && loggedIn" class="pl-5 text-uppercase"
                        [innerHTML]="subLinks['name'] | sanitizeHtml "></span>
                </a>

              </ng-container>
          </div>
          <ng-container *ngIf="featureTags && featureTags['sf_side_menu_contactus']">
              <div class="menu-item" *ngIf="subLinks['type'] === 'general' && !loggedIn">
                  <a mat-button *ngIf="subLinks['display'] && subLinks['display']['desktop'] === true" fxLayout="row"
                      fxLayoutAlign="start center" class="pl-0 textwrap" [routerLink]="['/contact']">
                      <mat-icon class="mat-icon-sm pad-right pl-10 pr-5"
                          *ngIf="subLinks['icon'] !== null && subLinks['iconType'] === 'material' && subLinks['type'] === 'general'">{{subLinks['icon']}}</mat-icon>
                      <span *ngIf="subLinks['type'] === 'general'"
                          class="pl-5 text-uppercase" [innerHTML]="subLinks['name'] | sanitizeHtml"></span>
                  </a>
              </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
    <div class="menu-item mb-25" *ngIf="featureTags && !featureTags['sf_side_menu_contactus']">
      <a mat-button fxLayout="row" fxLayoutAlign="start center" class="pl-0 bo-5" [routerLink]="['/contact']">
      <mat-icon class="mat-icon-sm pad-right pl-10 pr-5">phone</mat-icon>
      <span class="pl-5 text-uppercase">CONTACT US</span>
      </a>
    </div>
  </ng-container>
  